<div class="c-gp-credits-message">
	{{#if message}}
		<div class="msg-wrapper">
			<span class="msg-wrapper_msg">{{message}}</span>
			<a class="msg-wrapper_sign-up" href="https://globalping.io?view=add-credits">Sign up</a>
		</div>
	{{/if}}
</div>

<script>
	component.exports = {
		data () {
			return {
				message: null,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('rateCreditsData measurementErrMsg', () => {
					let rateCreditsData = this.get('rateCreditsData');
					let measurementErrMsg = this.get('measurementErrMsg');

					if (measurementErrMsg) {
						this.set('message', measurementErrMsg);
						return;
					}

					if (rateCreditsData) {
						let message;
						let hasToken = this.get('@shared.user');
						let resetsInPart = this.createResetInStr(rateCreditsData['x-ratelimit-reset']);

						if (hasToken) {
							message = this.createTokenCaseMsg(resetsInPart);
						} else {
							message = this.createNoTokenCaseMsg(resetsInPart);
						}

						this.set('message', message);
					}
				});
			}
		},
		oncomplete () {
			let el = document.querySelector('.c-gp-credits-message');

			setTimeout(() => {
				el.classList.add('show-msg');
			}, 200);
		},
		createResetInStr (seconds) {
			let minutes = seconds / 60;

			if (minutes < 1) {
				return '< 1 minute';
			}

			return `${Math.ceil(minutes)} minutes`;
		},
		createNoTokenCaseMsg (resetPart) {
			return `You have run out of credits for this session. You can wait ${resetPart} for the limit to reset or get higher limits by creating an account.`;
		},
		createTokenCaseMsg (resetPart) {
			return `You have run out of credits for this session. You can wait ${resetPart} for the limit to reset or get higher limits by sponsoring us or hosting probes.`;
		},
	};
</script>
